export const MAX_CONTAINER_WIDTH = 5000;
export const MAX_CONTAINER_HEIGHT = 5000;
